import { BarraLateral } from '../../containers/BarraLateral'
import { Formulario } from '../../containers/Formulario'

export const Cadastro = () => (
  <>
    <BarraLateral mostrarFiltros={false} />
    <Formulario />
  </>
)
